import { render, staticRenderFns } from "./companySituation.vue?vue&type=template&id=aa60d6f6&scoped=true&"
import script from "./companySituation.vue?vue&type=script&lang=js&"
export * from "./companySituation.vue?vue&type=script&lang=js&"
import style0 from "./companySituation.vue?vue&type=style&index=0&id=aa60d6f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa60d6f6",
  null
  
)

export default component.exports